module.exports = __webpack_public_path__ + "img/imac-2.21118035.jpeg";